import React, { useEffect } from "react";
import classNames from "classnames";
import HeaderLinks from "components/Header/HeaderLinks";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";

import { $FIXME } from "Helpers/constants";
import { Grid, TextField, Container } from "@mui/material";
import Parallax from "components/Parallax/Parallax";
import MyButton from "components/CustomButtons/Button";

import useStyles from "assets/styles";
import { envirnoment } from "envirnoment";

export default function TermsAndConditionsPage(props: $FIXME) {
	const classes = useStyles();
	const { ...rest } = props;
	useEffect(() => {
		(window as Window).scrollTo(0, 0);
	}, []);

	return (
		<div>
			<Header
				color="transparent"
				brand="My Cleaner Help"
				rightLinks={<HeaderLinks />}
				fixed
				changeColorOnScroll={{
					height: 200,
					color: "white",
				}}
				{...rest}
			/>
			<Parallax small image="/img/home/cleaning_services.webp">
				<div className={classes.container}>
					<Grid container style={{ zIndex: 19 }}>
						<Grid
							item
							xs={12}
							sm={12}
							md={12}
							className={classes.justifyCenter}
						>
							<h1 className={classes.titleWhite}>Terms and Conditions</h1>
						</Grid>
					</Grid>
				</div>
			</Parallax>
			<div
				className={classNames(
					classes.main,
					classes.mainRaised,
					classes.section
				)}
			>
				<Container>
					<Grid container>
						<Grid item xs={12} sm={12} md={12}>
							<h2 className={classes.title}>TERMS AND CONDITIONS</h2>
							<p className={classes.description}>
								Welcome to the My Cleaner Help website terms and conditions for
								use (“Terms”). These Terms apply to the use of this Website/app
								and by accessing this Website and/or making a Booking for
								Services you agree to be bound by the Terms set out below, the
								following document[s] also apply to your use of Our Site:
								<ul className={classes.description}>
									<li>Our Privacy Policy</li>
									<li>Our Cookie Policy </li>
								</ul>
								If you do not agree to be bound by these Terms, please do not
								use our website. Before you place an order with us, if you have
								any questions relating to these Terms, please contact our
								support team by email at <a> hello@mycleanerhelp.com </a>
							</p>
						</Grid>
						<Grid item xs={12} sm={12} md={12}>
							<h2 className={classes.title}> 1) DEFINITIONS</h2>
							<p className={classes.description}>
								<br />
								<span className="pl">“Booking”</span>
								means a booking for Services made by You on our Website
								<br />
							</p>
							<p className={classes.description}>
								<span className="pl">“Services”</span>
								means cleaning services or other home services;
								<br />
							</p>

							<p className={classes.description}>
								<span className="pl">“Service providers”</span>
								means a cleaner(s) or other home services provider available
								through our website;
								<br />
							</p>

							<p className={classes.description}>
								<span className="pl">“We/Us/Our” </span>
								means Prolijo Solutions LTD, we are a limited company registered
								in England and Wales under company number 13074886. Our
								registered address is 71-75 Shelton Street, London, Greater
								London, United Kingdom, WC2H 9JQ
								<br />
							</p>
							<p className={classes.description}>
								<span className="pl">“Website” </span>
								means the website located at <a>
									{" "}
									{envirnoment.websiteURL}{" "}
								</a>{" "}
								or any subsequent URL which may replace it;
								<br />
							</p>

							<p className={classes.description}>
								<span className="pl">“You” </span>
								means a user of this Website.
							</p>
						</Grid>

						<Grid item xs={12} sm={12} md={12}>
							<h2 className={classes.title}> 2) USE OF THE WEBSITE</h2>
							<p className={classes.description}>
								{" "}
								<span> 2.1 Access</span>
								<br />
								You are provided with access to this Website in accordance with
								these Terms and any Booking made by you must be placed strictly
								in accordance with these Terms.
								<p> </p>
								2.2 Registration,{" "}
								<span className="b-un semi-bold">
									{" "}
									Personal Information; User Accounts.{" "}
								</span>
								<br />
								<span className="semibold"> 2.2.1</span> By registering as a
								user of our website, you warrant that:
								<p> </p>
								<span className="semibold">(a)</span>the personal information
								which you provide when you register as a user and/or make a
								Booking is true, accurate, current and complete in all respects;
								and
								<p> </p>
								<span className="semibold">(b)</span> you will notify us
								immediately of any changes to this personal information by
								contacting our customer service representatives by email at{" "}
								<a>hello@mycleanerhelp.com</a>
								<p> </p>
								<span className="semibold"> 2.2.2</span> You agree not to
								impersonate any other person or entity or to use a false name or
								a name that you are not authorised to use.
								<br />
							</p>
							{/* <p */}
							<p className={classes.description}>
								a.{" "}
								<span className="b-un">
									Collection of your Personal Information.{" "}
								</span>
								Some of the materials available on the My Cleaner Help Platform
								may require prior registration to access. If you decide to
								access such materials you will be required to register. We may
								refuse to grant you, and you may not use, a username, email
								address or screen name that is already being used by someone
								else; that may be construed as impersonating another person;
								that belongs to another person; that violates the intellectual
								property or other rights of any person; that is offensive; or
								that we reject for any other reason in our sole discretion. When
								you complete a registration with us, you will be required to
								provide certain personal information. You agree that such
								information will be true, accurate and complete, and that you
								will update this information promptly when it changes. If you
								provide any information that is untrue or inaccurate, not
								current, or incomplete, or if we suspect that your information
								is untrue or inaccurate, not current, or incomplete, we may, in
								our sole discretion, suspend or terminate your right to access
								any material for which registration is required. Any personally
								identifiable information supplied hereunder will be subject to
								the terms of the Privacy Policy.
								<p> </p>
								<p className={classes.description}>
									{" "}
									b.{" "}
									<span className="b-un">
										{" "}
										Account, Password and Security.{" "}
									</span>{" "}
									You are the sole authorized user of your account. You are
									responsible for maintaining the confidentiality of any
									username, password and account provided by you or us for
									accessing the My Cleaner Help Platform. You are solely and
									fully responsible for all activities that occur under your
									password or account, except that My Cleaner Help may, in
									certain circumstances, access your account to make changes
									that you request, such as rescheduling a Service appointment.
									My Cleaner Help has no control over the use of any User's
									account by the User or third parties and expressly disclaims
									any liability derived therefrom. Should you suspect that any
									unauthorized party may be using your password or account or
									you suspect any other breach of security, you must contact us
									immediately athello@mycleanerhelp.com. Nothing in this section
									shall affect My Cleaner Help 's rights to limit or terminate
									the use of the My Cleaner Help Platform.
									<br />
								</p>
								<p>
									C.
									<span className="b-un"> Text Messages and Phone Calls. </span>
								</p>
								<br />
								(i) General: By using the My Cleaner Help platform, you
								expressly consent and agree to accept and receive communications
								from us, including via fax, text (SMS) messages, calls, push
								notifications and other reasonable means at any of your contact
								numbers or addresses, even if you are listed on any federal,
								state, provincial or other applicable "Do Not Call" list, in
								order that we may provide the services set forth on the My
								Cleaner Help Platform, to service your account, to reasonably
								address matters pertaining to your account, including but not
								limited to notifying you of, or confirming, appointments that
								you have scheduled, or for other purposes reasonably related to
								your service request and our business, including marketing
								related communications. By consenting to being contacted by My
								Cleaner Help, you understand and agree that you may receive
								communications, including marketing communications generated by
								automatic telephone dialing systems and/or which will deliver
								prerecorded messages, sent by or on behalf of My Cleaner Help,
								its affiliates, subsidiaries, parents and/or
								Users/Professionals, including but not limited to: operational
								communications concerning your account or use of the My Cleaner
								Help Platform or Services, updates concerning new and existing
								features on the My Cleaner Help Platform, communications
								concerning promotions run by us, and news concerning My Cleaner
								Help and industry developments. For certain Professional
								Services, you also expressly authorize My Cleaner Help to send
								you an automated prerecorded call confirming your Professional
								Services request, along with calls from up to four Professionals
								that can help you with your request to the land-line or mobile
								phone number you provided, and you understand that either My
								Cleaner Help or the Professionals may use automated phone
								technology (including autodialed and prerecorded messages) to
								call you and that your consent is not required to purchase
								products or services.
								<br />
								<br />
								(ii) Recording: You acknowledge that My Cleaner Help or its
								third party service providers may record customer service calls
								after notice to you and with your consent, in order to assist
								you when you contact our customer support services. You agree to
								My Cleaner Help 's use of a service provider to mask your
								telephone number when you call or exchange text (SMS) messages
								with a Professional or Requestor using a telephone number
								provided by My Cleaner Help. During this process, My Cleaner
								Help and its service provider will receive in real time and
								store call data, including the date and time of the call or text
								(SMS) message, the parties' phone numbers, and the content of
								the text (SMS) messages. You agree to the masking process
								described above and to My Cleaner Help 's use and disclosure of
								this call data for its legitimate business purposes.
								<br />
								<br />
								(iii) Provisions Specific to Text Messaging: i) Generally: You
								agree to receive recurring automated promotional and
								personalized marketing text (e.g., SMS and MMS) messages (e.g.
								cart reminders) from My Cleaner Help, including text messages
								that may be sent using an automatic telephone dialing system, to
								the mobile telephone number you provided when signing up or any
								other number that you designate. Consent to receive automated
								marketing text messages is not a condition of any purchase. Msg
								& Data rates may apply. Message frequency will vary. My Cleaner
								Help reserves the right to alter the frequency of messages sent
								at any time, so as to increase or decrease the total number of
								sent messages. My Cleaner Help also reserves the right to change
								the short code or phone number from which messages are sent and
								we will notify you when we do so. Not all mobile devices or
								handsets may be supported and our messages may not be
								deliverable in all areas. My Cleaner Help , its service
								providers and the mobile carriers supported by the program are
								not liable for delayed or undelivered messages. We are able to
								deliver messages to the following mobile phone carriers: Major
								carriers: AT&T, Verizon Wireless, Sprint, T-Mobile, MetroPCS,
								U.S. Cellular, Alltel, Boost Mobile, Nextel, and Virgin Mobile.
								Minor carriers: Alaska Communications Systems (ACS), Appalachian
								Wireless (EKN), Bluegrass Cellular, Cellular One of East Central
								IL (ECIT), Cellular One of Northeast Pennsylvania, Cincinnati
								Bell Wireless, Cricket, Coral Wireless (Mobi PCS), COX, Cross,
								Element Mobile (Flat Wireless), Epic Touch (Elkhart Telephone),
								GCI, Golden State, Hawkeye (Chat Mobility), Hawkeye (NW
								Missouri), Illinois Valley Cellular, Inland Cellular, iWireless
								(Iowa Wireless), Keystone Wireless (Immix Wireless/PC Man),
								Mosaic (Consolidated or CTC Telecom), Nex-Tech Wireless, NTelos,
								Panhandle Communications, Pioneer, Plateau (Texas RSA 3 Ltd),
								Revol, RINA, Simmetry (TMP Corporation), Thumb Cellular, Union
								Wireless, United Wireless, Viaero Wireless, and West Central
								(WCC or 5 Star Wireless). Text the keyword STOP, END, CANCEL,
								UNSUBSCRIBE or QUIT to our shortcode or in reply to a text
								message to cancel. After texting STOP, END, CANCEL, UNSUBSCRIBE
								or QUIT to our shortcode or in reply to a text message you will
								receive one additional message confirming that your request has
								been processed. You acknowledge that our text message platform
								may not recognize and respond to unsubscribe requests that do
								not include the STOP, END, CANCEL, UNSUBSCRIBE or QUIT keyword
								commands and agree that My Cleaner Help and its Service
								Providers will have no liability for failing to honor such
								requests. If you unsubscribe from one of our text message
								programs, you may continue to receive text messages from My
								Cleaner Help through any other programs you have joined until
								you separately unsubscribe from those programs. You acknowledge
								that by opting out of receiving text (SMS) messages from My
								Cleaner Help and the Service Professionals, your use of My
								Cleaner Help Services may be impacted. My Cleaner Help and its
								affiliates may view, store, access and disclose messages
								exchanged between you and consumers transmitted via My Cleaner
								Help 's messaging platform. Text the keyword HELP to our
								shortcode to return customer care contact information.
								<br />
								<br />
								(iv) False Information: TO KNOWINGLY INPUT FALSE INFORMATION,
								INCLUDING BUT NOT LIMITED TO NAME, PHONE NUMBER, ADDRESS OR
								E-MAIL ADDRESS IS A VERY SERIOUS AND FRAUDULENT MATTER THAT
								COULD RESULT IN SIGNIFICANT COSTS AND DAMAGES INCLUDING INVASION
								OF PRIVACY RIGHTS, TO MY CLEANER HELP AND THE PROFESSIONALS, AND
								TO CONSUMERS, AS WELL AS THE LOSS OF TIME, EFFORT AND EXPENSE
								RESPONDING TO AND PURSUING SUCH FALSE INFORMATION AND REQUEST,
								AND FURTHER, COULD RESULT IN REGULATORY FINES AND PENALTIES.
								ACCORDINGLY, IF YOU KNOWINGLY INPUT FALSE INFORMATION IN A
								SERVICE REQUEST, INCLUDING BUT NOT LIMITED TO SOME ONE ELSE'S
								NAME, E-MAIL ADDRESS, PHYSICAL ADDRESS OR PHONE NUMBER OR A
								RANDOM OR MADE UP NAME, ADDRESS, E-MAIL OR PHONE NUMBER YOU
								AGREE TO FULLY INDEMNIFY AND BE LIABLE TO MY CLEANER HELP AND
								EACH PROFESSIONAL WHO PROVIDES SUCH PROFESSIONAL SERVICES, FOR
								THE GREATER OF: (1) A MINIMUM AMOUNT OF $11,000 TO EACH OF MY
								CLEANER HELP AND EACH OF THE AFFECTED PROFESSIONALS AND FOR EACH
								OF THE ACTUAL PERSON(S) AFFECTED BY ANY OF THE IMPROPER,
								INCORRECT OR FRAUDULENT INFORMATION YOU ENTER (FOR EXAMPLE THE
								ACTUAL OWNER OF THE E-MAIL ADDRESS OR PHONE NUMBER, ETC.), PER
								IMPROPER SUBMISSION, PLUS ANY ATTORNEYS FEES COSTS AND EXPENSE
								RELATING THERETO, IF APPLICABLE, OR (2) THE ACTUAL DAMAGES,
								DIRECT, PUNITIVE AND CONSEQUENTIAL, AND ANY REGULATORY OR
								JUDICIAL FINES OR PENALTIES THAT MAY ARISE FROM SUCH
								INTENTIONAL, MISLEADING, HARMFUL AND FRAUDULENT ACTIVITY, PLUS
								REASONABLE LEGAL FEES, COST AND EXPENSES RELATING THERETO, WHICH
								EVER IS GREATER.
								<p className={classes.description}>
									e.
									<span className="b-un">Emails.</span>
									My Cleaner Help may send you confirmation and other
									transactional emails regarding the Professional Services. My
									Cleaner Help and its affiliates, subsidiaries, parents may
									also send you emails about other services that we think might
									interest you ("Promotional Emails"). You can unsubscribe from
									Promotional Emails at any time by clicking unsubscribe in our
									email communications or contacting us.
								</p>
								<br />
								<span>The App / Mobile Devices</span>
								<br />
								<br />
								a. The My Cleaner Help Platform may allow you to access our
								services, download our Apps, upload content to the My Cleaner
								Help Platform, and receive messages on your mobile device
								(collectively "Mobile Features"). Your mobile device carrier may
								prohibit or restrict certain Mobile Features and certain Mobile
								Features may be incompatible with your mobile device carrier or
								mobile device. In addition, your mobile device carrier may
								charge you for standard messaging, data, and other fees to
								participate in Mobile Features. We have no responsibility or
								liability for any fees or charges you incur when using the
								Mobile Features. You should check with your mobile device
								carrier to find out whether any fees or charges will apply, what
								plans are available and how much they cost. You should also
								contact your mobile device carrier with any other questions
								regarding these issues.
								<br />
								b. You acknowledge that your use of the Apps is subject to any
								terms set forth in the terms of service of the third party
								providing the mobile device on which the App operates (e.g.,
								Apple iOS or Android).
								<br />
								c. My Cleaner Help is not liable if you do not have a compatible
								mobile device or if you download the wrong version of an App for
								your mobile device. My Cleaner Help reserves the right to
								terminate the use of the Apps or any other aspect of the My
								Cleaner Help Platform should you be using the Apps or the My
								Cleaner Help Platform with an incompatible or unauthorized
								device.
								<br />
								<p className={classes.description}>
									d.
									<span className="b-un">App Store Sourced Application.</span>
									<br />
									<br />
									(i) With respect to Apps accessed through or downloaded from
									the Apple App Store ("App Store Sourced Application"), you
									will use the App Store Sourced Application only: (i) on an
									Apple-branded product that runs iOS (Apple's proprietary
									operating system software); and (ii) as permitted by the
									"Usage Rules" set forth in the Apple App Store Terms of
									Service. My Cleaner Help reserves all rights in and to the
									Apps not expressly granted to you under this Agreement.
									<br />
									<br />
									(ii) You acknowledge and agree that (i) this Agreement is
									valid between you and My Cleaner Help only, and, that Apple is
									not a party to this Agreement other than as third-party
									beneficiary as contemplated below, and (ii) My Cleaner Help,
									not Apple, is solely responsible for the App Store Sourced
									Application and the My Cleaner Help Platform Content.
									<br />
									<br />
									(iii) You acknowledge that Apple has no obligation whatsoever
									to furnish any maintenance or support services to you with
									respect to the App Store Sourced Application.
									<br />
									<br />
									(iv) To the maximum extent permitted by applicable law, Apple
									will have no warranty obligation whatsoever with respect to
									the App Store Sourced Application.
									<br />
									<br />
									(v) Notwithstanding anything to the contrary herein, and
									subject to the terms in this Agreement, you acknowledge that,
									solely as between Apple and My Cleaner Help , My Cleaner Help
									and not Apple is responsible for addressing any claims you may
									have relating to the App Store Sourced Application, or your
									possession and/or use thereof, including, but not limited, to:
									(i) product liability claims, (ii) any claim that the App
									Store Sourced Application fails to conform to any applicable
									legal or regulatory requirement; and (iii) claims arising
									under consumer protection or similar legislation.
									<br />
									<br />
									(vi) Further, you agree that if the App Store Sourced
									Application, or your possession and use of the App Store
									Sourced Application, infringes on a third party's intellectual
									property rights, you will not hold Apple responsible for the
									investigation, defense, settlement and discharge of any such
									intellectual property infringement claims.
									<br />
									<br />
									(vii) You acknowledge and agree that Apple, and Apple's
									subsidiaries, are third-party beneficiaries of this Agreement
									for App Store Sourced Applications, and that, upon your
									acceptance of the terms and conditions of this Agreement,
									Apple will have the right (and will be deemed to have accepted
									the right) to enforce this Agreement for App Store Sourced
									Applications against you as a third-party beneficiary thereof.
									<br />
									(viii) Without limiting any provisions of this Agreement, you
									must comply with all applicable third party terms of agreement
									when using the App Store Sourced Application.
								</p>
								<p className={classes.description}>
									<span className="pl fontLarge">2.3 Our rights</span>
									<br />
									<br />
									We reserve the right to:
									<br />
								</p>
								<p className={classes.description}>
									<span className="pl">(a)</span>
									modify or withdraw, temporarily or permanently, this Website
									(or any part thereof) with or without notice to you and you
									confirm that we shall not be liable to you or any third party
									for any modification to or withdrawal of the Website; and/or
									<br />
								</p>
								<p className={classes.description}>
									<span className="pl">(b)</span>
									change these Terms from time to time as explained below. If
									you do not agree to such amended terms, you must stop using
									the Website. If you continue to use the Website you will be
									deemed to have accepted the amended terms
									<br />
								</p>
							</p>

							<Grid item xs={12} sm={12} md={12}>
								<h2 className={classes.title}>
									3) MY CLEANER HELP SERVICES PLATFORM
								</h2>

								<p className={classes.description}>
									<span className="pl">3.1</span>
									We act as a booking agency for self-employed Service
									provider(s). Our contract with you is limited to provision of
									use of our website.
									<br />
									<span className="pl">3.2</span>
									Your Service provider(s) is responsible for providing the
									Services to you and you have a direct contract between you and
									the Service provider(s) concerning the provision of Services.
									This contract does not include us. You and Service provider(s)
									are responsible for any taxes arising as a result of the
									Services.
									<br />
									<span className="pl">3.3</span>We review applications, conduct
									interviews and undertake other checks of Service provider(s),
									with some of this process reliant on information from or
									undertaken by third parties. You acknowledge that we do not
									and cannot guarantee the accurateness or completeness of such
									checks, whether conducted by us or by third parties.
									<br />
									<span className="pl">3.4</span>You acknowledge that you use
									Service provider(s) at your own risk. You agree to provide a
									safe working environment for Service provider(s) and to take
									appropriate precautions to supervise Service provider(s).
								</p>
							</Grid>
						</Grid>
						<Grid item xs={12} sm={12} md={12}>
							<h2 className={classes.title}> 4) BOOKING SERVICES</h2>
							<br />
							<p className={classes.description}>
								<span className="pl">4.1</span>
								By placing an order through our website, you warrant that you
								are: legally capable of entering into binding contracts, and at
								least 18 years old.
								<br />
								<br />
								<span className="pl">4.2</span>
								All Bookings are subject to acceptance by us, and we will
								confirm such acceptance to you by sending you an email on behalf
								of the selected Service provider(s) to confirm the Booking (the
								“Visit Confirmation”). The contracts between us and you and
								between you and the Service provider(s) will only be formed when
								we send you the Visit Confirmation.
								<br />
								<br />
								<span className="pl">4.3</span>
								You agree that you will not seek to book any Services from any
								Service provider(s) other than via our Website for the duration
								of this agreement and in the 3 months after termination of this
								agreement.
							</p>

							<Grid item xs={12} sm={12} md={12}>
								<h2 className={classes.title}>5) PRICE AND PAYMENT</h2>
								<p className={classes.description}>
									<span className="pl">5.1</span>
									The price of any Services will be as quoted on our website,
									except in cases of obvious error.
									<br />
									<br />
									<span className="pl">5.2</span>
									Prices are liable to change at any time, but changes will not
									affect orders in respect of which we have already sent you a
									Visit Confirmation email.
									<br />
									<br />
									<span className="pl">5.3</span> Every effort has been made on
									this Website to ensure that making a Booking is secure. We
									cannot be responsible for fraudulent use on our website of a
									lost payment card.
									<br />
									<br />
									<span className="pl">5.4</span> You must maintain a valid
									payment card with us. You must inform us immediately if your
									payment card details are no longer valid.
									<br />
									<br />
									<span className="pl">5.5</span> You authorise us to seek
									pre-authorisation of your payment card. You also authorise us
									to charge your payment card in full on the day of the
									scheduled Booking or after the scheduled Booking.
									<br />
									<br />
									<span className="pl">5.6</span> If any amount due by you is
									unpaid after the day of the scheduled Booking, we may charge a
									£10 administration fee and interest each month.
									<br />
									<br />
									5.7
									<span className="pl fontLarge">Promotional Coupons:</span>
									<br />
									<br />
									i. Promotional coupons are only eligible for the specific
									services designated by My Cleaner Help . Promotional coupons
									are valid for a limited time only and expires on the date
									indicated when you receive the applicable promotional coupon.
									Failure to use promotional coupons before such expiration date
									will result in the forfeiture of the promotional coupon. My
									Cleaner Help reserves the right to cancel promotional coupons
									at any time. No refunds will be granted for any expired or
									canceled promotional coupons
									<br />
									<br />
									ii. My Cleaner Help promotional coupons have no intrinsic
									value, are not redeemable for cash, have no cash value, and
									serve merely as a means to recognize and provide an incentive
									to use the My Cleaner Help Platform. Promotional coupons may
									not be purchased for cash and My Cleaner Help does not sell
									promotional coupons. Promotional coupons are nonrefundable.
									<br />
									<br />
									iii. Promotional coupons will not be applied against any
									sales, use, gross receipts or similar transactionbased taxes
									that may be applicable to you, and/or fees or charges for use
									of any ineligible services.
									<br />
									<br />
									iv. Your My Cleaner Help account will be billed for all fees
									and charges for use of any ineligible services. Each
									promotional coupon can only be used once and your My Cleaner
									Help account will be billed for all fees and charges for use
									of any eligible service in excess of the amount of available
									promotional coupon.
									<br />
									<br /> 5.8 My cleaner help, operates a referral scheme that is
									open to selected users and is accessible from your account.
									You can share your referral code or link with people you know,
									who do not live at the same address as you and who you think
									would benefit from the My cleaner help service. If a new user
									uses your referral code, you and your referred user may be
									eligible for referral benefits. Referral codes and links must
									only be used for personal, non-commercial purposes. For
									example, you may share your referral code or link on your
									personal social media accounts, but you agree that you will
									not share them on websites where you are not the account
									owner, including (but not limited to) Facebook business
									accounts or groups, Wikipedia, Google Reviews, coupon
									websites, and nor will you promote your referral code or link
									via advertising platforms including (but not limited to)
									Google Ads and Bing. We reserve the right to withdraw and
									deactivate your referral code, link and referral benefits at
									any time and will not be responsible for any losses you suffer
									if we withdraw and deactivate your referral code, link or
									referral benefits.
									<br />
									<br />
									5.9 My cleaner help, may at its sole discretion offer its own
									discounts and promotional offers (“My cleaner help promotional
									offers”) to potential and existing customers to promote My
									cleaner help’s business as an agent. These offers will not
									reduce the consideration received by the cleaner and may
									therefore entail My cleaner help subsidising the consideration
									due to the cleaner in some circumstances. The customer
									acknowledges that any consideration paid by the customer as
									part of a My cleaner help promotional offer up to the amount
									of consideration that would otherwise be due to the cleaner at
									the agreed standard rates is wholly consideration due to the
									cleaner.
									<br />
									<h6 className="b-un"> e. Gift Cards</h6>
									i. My Cleaner Help, Gift Cards ("<span>Cards Gift</span>") are
									redeemable only for Professional Services. Gift Cards have no
									cash value and are not redeemable for cash unless otherwise
									required by law.
									<br />
									ii. Gift Cards must be presented at the time of purchase and
									any available balance will be applied to your purchase.
									<br />
									<br />
									iii. Gift Cards do not expire and there are no inactivity,
									dormancy or service fees associated with Gift Cards.
									<br />
									<br />
									iv. You agree that you will comply with all Gift Card terms
									and conditions.
									<br />
									<br />
									v. Gift Cards are not replaceable if lost or stolen, and
									cannot be combined with any other Gift Cards, Vouchers, gift
									certificates, or other coupons.
									<br />
									<br />
									vi. Gift Cards cannot be used for previous purchases, credits,
									or the purchase of Gift Cards, and cannot be used to make a
									payment towards third party items the balance on a credit
									card.
									<br />
									<br />
									vii. We reserve the right to limit quantities of Gift Cards
									purchased by any person or entity and to cancel a Gift Card if
									we believe that the Gift Card was obtained through fraudulent
									or unauthorized means. Specifically, you may not purchase or
									obtain more than £ 5,000 in Gift Card value in any one day
									regardless of location, whether on a single Gift Card or
									multiple Gift Cards. Moreover, you may not purchase or obtain
									any one Gift Card with a value of more than £ 2,000 in any one
									day.
									<br />
									<br />
									viii. No credit card, credit line, overdraft protection, or
									deposit account is associated with your Gift Card. Unused Gift
									Card balances are not transferable, and you may not sell a
									Gift Card or otherwise barter for its exchange although you
									may give a Gift Card to someone else as a gift.
									<br />
									<br />
									ix. A Gift Card is void if copied, altered, transferred,
									purchased or sold.
									<br />
									<br />
									x. Purchases of Gift Cards are final and not refundable. All
									sales are final
									<br />
									<br />
									xi. We reserve the right to correct the balance of a Gift Card
									if we believe that a billing error has occurred, and we
									disclaim all liability for any such billing errors.
									<br />
									<br />
									xii. Gift Cards and their use are subject to this Agreement
									(including the Privacy Policy) and use of a Gift Card
									constitutes acceptance thereof. Applicable terms and
									conditions are subject to change without notice. If the laws
									pertaining to a Gift Card require additional or different
									terms and conditions, then such terms and conditions shall
									apply. For questions or additional information, contact us at
									<a href="https://MyCleanerHelp.com/help">
										www.My Cleaner Help .com/help.
									</a>
									<br />
									<br />
									xiii. In the event you do not use your Gift Card for a certain
									period of time, we may be required to turn over the remaining
									Gift Card balance to a state under such state's unclaimed or
									abandoned property law. Although your Gift Card does not
									expire, if we are obligated to turn over the remaining balance
									of your Gift Card under a state's unclaimed property law, by
									operation of law we will be released from any further
									liability or obligation with respect to your Gift Card and you
									may be required to contact the state's unclaimed property
									administrator to attempt to recover your unused Gift Card
									balance. To protect your right to continue to use your
									remaining Gift Card balance, we will make reasonable efforts
									to exempt your Gift Card from state unclaimed property laws.
								</p>
							</Grid>

							<Grid item xs={12} sm={12} md={12}>
								<h2 className={classes.title}>6) BOOKING CANCELLATION BY US</h2>
								<p className={classes.description}>
									<span> 6.1</span> If you violate any of the Terms, your
									permission to use the Services and Website will automatically
									terminate.
									<br />
									<br />
									<span> 6.2</span>We reserve the right to cancel any Booking
									without notice or cause.
									<br />
									<h2 className={classes.title}>
										7) BOOKING CANCELLATION BY YOU
									</h2>
									<br />
									<span> 7.1</span> You may cancel or reschedule a Booking until
									18:00 the day before the Booking for free.
									<br />
									<br />
									<span> 7.2</span> For cancellations after 18:00 the day before
									the Booking, or if your Housekeeper arrives for the clean and
									is unable to gain entry or start the clean, you will be
									charged the full price of the Booking.
									<br />
									<h2 className={classes.title}> 8) INSURANCE</h2>
									<br />
									<span> 8.1</span> We have a £1m public liability insurance
									policy underwritten by a leading insurer. There are excesses
									of at least £250, depending on the specific type of claim,
									which will be at your cost.
									<span> 8.2</span> This policy is only able to cover
									extreme circumstances, for example, serious injury to the
									Housekeeper or severe damage to property such as fire.
									<br />
									<h2 className={classes.title}> 9) THIRD PARTY LINKS</h2>
									<br />
									Links to third party websites on the Website are provided
									solely for your convenience. If you use these links, you leave
									the Website. We have not reviewed any of these third party
									websites and do not control and are not responsible for these
									websites or their content or availability. We therefore do not
									endorse or make any representations about them, or any
									material found there, or any results that may be obtained from
									using them. If you decide to access any of the third party
									websites linked to the Website, you do so entirely at your own
									risk.
									<br />
									<h2 className={classes.title}> 10) PRIVACY</h2>
									<br />
									We process information about you in accordance with our
									Privacy Policy. By using our website, you consent to such
									processing and you warrant that all data provided by you is
									accurate.
								</p>
							</Grid>
							<Grid item xs={12} sm={12} md={12}>
								<h2 className={classes.title}>11) LIABILITY</h2>
								<p className={classes.description}>
									<span className="pl">11.1</span>
									Our liability for losses you suffer as a result of us breaking
									this agreement is strictly limited to the purchase price of
									the Services you purchased in the previous six months.
									<br />
									<br />
									<span className="pl">11.2</span>
									This limitation does not include or limit in any way our
									liability for death or personal injury caused by our
									negligence, fraud or fraudulent misrepresentation, or any
									matter for which it would be illegal for us to exclude, or
									attempt to exclude, our liability.
									<br />
									<br />
									<span className="pl">11.3</span>
									We are not responsible for indirect losses which happen as a
									side effect of the main loss or damage, including but not
									limited: to loss of income or revenue; loss of business; loss
									of profits or contracts; loss of anticipated savings; loss of
									data; or, waste of management or office time however arising
									and whether caused by by tort (including negligence), breach
									of contract or otherwise.
									<br />
									<br />
									<span className="pl">11.4</span>
									We will take all reasonable care, in so far as it is in our
									power to do so, to keep the details of your Booking and
									payment secure, but in the absence of negligence on our part
									we cannot be held liable for any loss you may suffer if a
									third party procures unauthorised access to any data you
									provide when accessing or ordering from the Website.
									<h2 className={classes.title}>
										 12) EVENTS OUTSIDE OUR CONTROL
									</h2>
									<span className="pl">12.1</span>
									We will not be liable or responsible for any failure to
									perform, or delay in performance of, any of our obligations
									under a Contract that is caused by events outside our
									reasonable control (“Force Majeure Event”).
									<br />
									<br />
									<span className="pl">12.2</span>
									A Force Majeure Event includes any act, event, non-happening,
									omission or accident beyond our reasonable control and
									includes in particular (without limitation) the following:
									strikes, lock outs or other industrial action; civil
									commotion; riot; invasion; terrorist attack or threat of
									terrorist attack; war (whether declared or not) or threat or
									preparation for war; fire, explosion, storm, flood,
									earthquake, subsidence, epidemic or other natural disaster;
									impossibility of use of railways, shipping, aircraft, motor
									transport or other means of public or private transport;
									impossibility of the use of public or private
									telecommunications networks; acts, decrees, legislation,
									regulations or restrictions of any government.
									<br />
									<br />
									<span className="pl">12.3</span>
									Our performance under any Contract is deemed to be suspended
									for the period that the Force Majeure Event continues, and we
									will have an extension of time for performance for the
									duration of that period. We will use our reasonable endeavours
									to bring the Force Majeure Event to a close or to find a
									solution by which our obligations under the Contract may be
									performed despite the Force Majeure Event.
								</p>
							</Grid>
						</Grid>
						<Grid item xs={12} sm={12} md={12}>
							<h2 className={classes.title}> 13) GENERAL</h2>
							<p className={classes.description}>
								<span className="pl">13.1</span> Intellectual property and right
								to use
								<br />
								<span className="pl">13.1.1</span> Unless otherwise stated, the
								copyright and other intellectual property rights in the content
								on the Website are owned by us or our licensors. Any access or
								use of the Website for any reason other than your personal,
								non-commercial use is prohibited.
								<br />
								<br />
								<span className="pl">13.1.2</span> No part of the Website may be
								reproduced or stored in any other website or included in any
								public or private electronic retrieval system or Website without
								our prior written permission.
								<br />
								<br />
								<span className="pl">13.1.3</span> You acknowledge and agree
								that the material and content contained within the Website is
								made available for your personal non-commercial use only and
								that you may download such material and content onto only one
								computer hard drive for such purpose. Any other use of the
								material and content of the Website is strictly prohibited.
								<br />
								<br />
								<span className="pl">13.1.4</span>
								You agree not to (and agree not to assist or facilitate any
								third party to) copy, reproduce, transmit, publish, display,
								distribute, commercially exploit or create derivative works of
								such material and content.
								<br />
								<br />
								<span className="pl">13.1.5</span>
								If you publish any content on our Website, such as reviews,
								comments, ratings, profiles or listings, you grant us a
								worldwide, perpetual, non-exclusive, royalty-free licence to
								copy, alter, adapt or display such Content on our Website.
								<br />
								<br />
								<span className="pl fontLarge">13.2 Compliance with laws</span>
								<br />
								<br />
								The Website may be used only for lawful purposes and in a lawful
								manner. You agree to comply with all applicable laws, statutes
								and regulations regarding the Website and any transactions
								conducted on or through the Website.
								<br />
								<br />
								<span className="pl fontLarge">
									13.3 Written Communications
								</span>
								<br />
								<br />
								Applicable laws require that some of the information or
								communications we send to you should be in writing. When using
								our site, you accept that communication with us will be mainly
								electronic. We will contact you by email or provide you with
								information by posting notices on our website. For contractual
								purposes, you agree to this electronic means of communication
								and you acknowledge that all contracts, notices, information and
								other communications that we provide to you electronically
								comply with any legal requirement that such communications be in
								writing. This condition does not affect your statutory rights.
								<br />
								<br />
								<span className="pl fontLarge">13.4 Notices</span>
								<br />
								<br />
								All notices given by you to us must be given to
								hello@mycleanerhelp.com We may give notice to you at either the
								email or postal address you provide to us when making a Booking,
								or as specified above. Notice will be deemed received and
								properly served immediately when posted on our website, 24 hours
								after an email is sent, or three days after the date of posting
								of any letter. In proving the service of any notice, it will be
								sufficient to prove, in the case of a letter, that such letter
								was properly addressed, stamped and placed in the post and, in
								the case of an email that such email was sent to the specified
								email address of the addressee.
								<br />
								<br />
								<span className="pl fontLarge">
									13.5 Transfer of rights and obligations
								</span>
								<br />
								<br />
								<span className="pl">13.5.1</span>
								The contract between you and us is binding on you and us and on
								our respective successors and assigns.
								<br />
								<br />
								<span className="pl">13.5.2</span>
								You may not transfer, assign, charge or otherwise dispose of a
								Contract, or any of your rights or obligations arising under it,
								without our prior written consent.
								<br />
								<br />
								<span className="pl">13.5.2</span>
								We may transfer, assign, charge, sub-contract or otherwise
								dispose of a Contract, or any of our rights or obligations
								arising under it, at any time during the term of the Contract.
								<br />
								<br />
								<span className="pl fontLarge">13.6 Severance</span>
								<br />
								<br />
								If any part of these Terms shall be deemed unlawful, void or for
								any reason unenforceable, then that provision shall be deemed to
								be severable from these Terms and shall not affect the validity
								and enforceability of any of the remaining provisions of these
								Terms.
								<br />
								<br />
								<span className="pl fontLarge">13.7 Waiver</span>
								<br />
								No waiver by us shall be construed as a waiver of any proceeding
								or succeeding breach of any provision.
								<br />
								<br />
								<span className="pl fontLarge">13.8 Entire Agreement</span>
								<br />
								<br />
								These Terms and any document expressly referred to in them
								constitute the entire agreement between us with respect to the
								subject matter of any contract and supersedes any previous
								communications or agreements between us.
								<br />
								<br />
								<span className="pl fontLarge">
									13.9 Our Right to Vary these Terms
								</span>
								<br />
								<br />
								We have the right to revise and amend these Terms from time to
								time. You will be subject to the policies and Terms in force at
								the time that you book Services from us. Please regularly check
								on our Website for new versions.
								<br />
								<br />
								<span className="pl fontLarge">13.10 Law</span>
								<br />
								<br />
								These Terms and the Contracts shall be governed by and construed
								in accordance with the laws of England and you irrevocably
								submit to the exclusive jurisdiction of the courts of England.
								Any dispute or claim arising out of or in connection with the
								Contracts or their formation (including non-contractual disputes
								or claims) shall be subject to the exclusive jurisdiction of the
								courts of England and Wales.
								<br />
								<br />
								<span className="pl fontLarge">13.11 Contact Information</span>
								<br />
								<br />
								We can be contacted by email at Hello@mycleanerhelp.com and by
								post at 71-75 Shelton Street, London, Greater London, United
								Kingdom, WC2H 9JQ
								<br />
								<div className="bottomdiv">
									<p className="w-80">
										I HEREBY ACKNOWLEDGE THAT I HAVE READ AND UNDERSTAND THESE
										TERMS OF USE AND PRIVACY POLICY, AND AGREE THAT MY USE OF
										THE HANDY PLATFORM IS AN ACKNOWLEDGMENT OF MY AGREEMENT TO
										BE BOUND BY ALL OF THE TERMS AND CONDITIONS OF THIS
										AGREEMENT.
									</p>
								</div>
								Last updated: <span>November 9, 2022</span>
							</p>
						</Grid>
					</Grid>
				</Container>

				<div className={classes.yellowContainer}>
					<Grid container spacing={5} className={classes.container}>
						<Grid
							item
							sm={4}
							md={4}
							className={classes.justifyCenter}
							style={{
								display: "flex",
								flexDirection: "column",
							}}
						>
							<h2 className={classes.title}>Want a Quote?</h2>
						</Grid>
						<Grid item xs={12} sm={12} md={4} className={classes.justifyCenter}>
							<h3 className={classes.title}>Email US!</h3>
							<TextField
								fullWidth
								label="Email Address"
								margin="normal"
								name="email"
								type="email"
								variant="outlined"
							/>
							<MyButton type="primary" label="Get Quote!" />
						</Grid>
					</Grid>
				</div>
			</div>
			<Footer />
		</div>
	);
}
